import { render, staticRenderFns } from "./SearchPsychologistPage.vue?vue&type=template&id=4c429d34&scoped=true&"
import script from "./SearchPsychologistPage.vue?vue&type=script&lang=ts&"
export * from "./SearchPsychologistPage.vue?vue&type=script&lang=ts&"
import style0 from "./SearchPsychologistPage.vue?vue&type=style&index=0&id=4c429d34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c429d34",
  null
  
)

export default component.exports